import type { App } from "vue";
import * as PresentationComponents from "@/modules/Presentation/Templates";
import TouchButton from "./modules/Presentation/Components/TouchButton.vue";
import { Transitions } from "@/modules/Presentation/Transitions";

const GlobalComponents: Record<string, any> = {
    'Page': PresentationComponents.Page,
    'Animated': PresentationComponents.Animated,
    'Triggered': PresentationComponents.Triggered,
    'Image': PresentationComponents.Image,
    'ImageAndText': PresentationComponents.ImageAndText,
    'KeyMessage': PresentationComponents.KeyMessage,
    'Video': PresentationComponents.Video,
    'TouchButton': TouchButton,
};

export function useGlobalComponents()
{
    return {
        install: ( app: App ) =>
        {

            // Remove the Image component registered in the CV Library as its not used and
            // we will be adding another with the same name in the Presentations module
            delete app._context.components[ "Image" ]; 
            
            for( const key in GlobalComponents )
            {
                app.component( key, GlobalComponents[ key ] );
            }
        }
    };
};